/**
 * Ключи примеров запросов для анализа (соответствуют examples.json).
 * Тексты берутся через i18n с учётом текущего языка.
 */
export const EXAMPLE_QUERY_KEYS = Array.from({ length: 84 }, (_, i) => i);

export type ExampleQueryT = (key: string, options?: { ns?: string }) => string;

/**
 * Получить случайный пример запроса на текущем языке, исключая текущий текст
 * @param t - функция перевода (i18n t)
 * @param currentQuery - текущий запрос, который нужно исключить
 * @returns переведённый пример запроса
 */
export const getRandomExample = (
  t: ExampleQueryT,
  currentQuery: string = ''
): string => {
  const shuffled = [...EXAMPLE_QUERY_KEYS].sort(() => Math.random() - 0.5);
  for (const key of shuffled) {
    const text = t(key.toString(), { ns: 'examples' });
    if (text !== currentQuery) return text;
  }
  return t(EXAMPLE_QUERY_KEYS[0].toString(), { ns: 'examples' });
};

